import InputField from "@_common/InputRuleFeild";
import { tableStatusColors } from "@_common/colors";
import { convertCurrentDate } from "@_common/date-helpers";
import { formatText } from "@_common/format-text";
import { changeLegalDuedate } from "@services/task.service";
import { getValue } from "@utils/lodash";
import moment from "moment";
import * as React from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledAccordion,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import OrganizationInformationSvgComponent from "../../assets/svg-components/task-details/organization-information";
import RedoSvgComponent from "../../assets/svg-components/task-details/redo";
import ApprovalFlowSvgComponent from "../../assets/svg-components/task-details/approval-flow";
import EntityMappingSvgComponent from "../../assets/svg-components/task-details/entity-mapping";
import EntityMappingDetailsSvgComponent from "../../assets/svg-components/task-details/entity-mapping-details";
import AdditionalInfoSvgComponent from "../../assets/svg-components/task-details/additional-info";

interface IOrganizationInformationCommonProps {
  data: object;
  headerObj: object | any;
  getData: () => void;
}

const OrganizationInformationCommon = (props: any) => {
  const [levels] = React.useState([
    "level_1",
    "level_2",
    "level_3",
    "level_4",
    "level_5",
    "level_6",
    "level_7",
    "level_8",
    "level_9",
    "level_10",
  ]);

  const mainParams = useParams();
  const { data, headerObj } = props;

  const isDateGreaterThanToday = (dateString: string) => {
    let date = new Date(dateString);
    const providedDate = moment(date, "YYYY-MM-DD");
    const todayDate = moment().startOf("day"); // Set time to the start of today
    return providedDate.isSameOrAfter(todayDate, "day"); // Compare up to the day level
  };

  const user = JSON.parse(String(localStorage.getItem("user")));
  const is_super_user = user.is_super_admin;
  const [isOpen, setIsOpen] = React.useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [legal_due_date, setLegal_due_date] = React.useState<any>(null);

  const [submitLoading, setSubmitLoading] = React.useState(false);
  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      let resp = await changeLegalDuedate(getValue(mainParams, `id`, ""), {
        legal_due_date: legal_due_date,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSubmitLoading(false);
        setLegal_due_date("");
        props.getData();
        handleModal();
      } else {
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };
  return (
    <div className="map-vendor__check map-vendor__check--task-details">
      {/* <h4 className="map-vendor__task-title">Additional Information</h4> */}
      {/* <h4 className="map-vendor__task-title">Organization Information</h4> */}
      <div className="d-flex align-items-center master-details-header">
        <AdditionalInfoSvgComponent />
        <h4 className="master-details-title">Additional Information</h4>
      </div>

      <UncontrolledAccordion
        open="1"
        defaultOpen="1"
        className="additional-information-accordion-wrap"
      >
        <AccordionItem>
          <AccordionHeader targetId="1">
            <div className="accordian-header-wrap d-flex align-items-center">
              <OrganizationInformationSvgComponent />
              <div className="accordion-header-title">Task Information</div>
            </div>
          </AccordionHeader>
          <AccordionBody accordionId="1">
            <div className="org-info-body-wrap">
              <div className="org-info d-flex align-items-center">
                <RedoSvgComponent />
                <div className="org-info-label-value-wrap">
                  <div className="org-info-label">Compliance Status</div>

                  <div className="org-info-value">
                    {formatText(getValue(data, `compliance_status`, ""))}
                  </div>
                </div>
              </div>

              <div className="org-info d-flex align-items-center">
                <RedoSvgComponent />
                <div className="org-info-label-value-wrap">
                  <div className="org-info-label">Task ID</div>

                  <div className="org-info-value">
                    {getValue(data, `task_id`, "")}
                  </div>
                </div>
              </div>
              <div className="org-info d-flex align-items-center">
                <RedoSvgComponent />
                <div className="org-info-label-value-wrap">
                  <div className="org-info-label">Legal Due Date</div>

                  <div className="org-info-value">
                    {convertCurrentDate(getValue(data, `legal_due_date`, ""))}
                  </div>
                  {getValue(props, `permissions`, []).includes("update") &&
                    getValue(data, `compliance_status`, "") !== "COMPLIED" &&
                    isDateGreaterThanToday(
                      getValue(data, `legal_due_date`, ""),
                    ) &&
                    is_super_user && (
                      <div className="edit-legal-due-date-icon">
                        <img
                          src="/images/edit-new.svg"
                          className="img-fluid cursor-pointer"
                          style={{ height: "24px", width: "24px" }}
                          onClick={() => {
                            setLegal_due_date(
                              new Date(getValue(data, `legal_due_date`, null)),
                            );
                            handleModal();
                          }}
                        />
                      </div>
                    )}
                </div>
              </div>
            </div>
          </AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>

      <UncontrolledAccordion
        open="2"
        defaultOpen="2"
        className="additional-information-accordion-wrap"
      >
        <AccordionItem>
          <AccordionHeader targetId="2">
            <div className="accordian-header-wrap d-flex align-items-center">
              <ApprovalFlowSvgComponent />
              <div className="accordion-header-title">Approval Flow</div>
            </div>
          </AccordionHeader>
          <AccordionBody accordionId="2">
            <div className="org-info-body-wrap">
              <div className="org-info d-flex align-items-center approval-flow-info is-arrow ">
                <span className="border-arrow-holder"></span>
                <div
                  className="approval-profile-wrap"
                  style={{
                    background: "#1D4D40",
                    border: "1px solid #1D4D40",
                  }}
                >
                  <span className="m-auto">
                    {getValue(data, `executor.first_name`, "").charAt(0)
                      .length > 0
                      ? getValue(data, `executor.first_name`, "")
                          .charAt(0)
                          .toUpperCase()
                      : "A"}
                  </span>
                </div>
                <div className="org-info-label-value-wrap approval-flow-label-value-wrap w-100">
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="org-info-label">Executor</div>

                      <div className="org-info-value">
                        {getValue(data, `executor.first_name`, "") +
                          " " +
                          getValue(data, `executor.last_name`, "")}
                      </div>
                    </div>

                    <div className="text-right">
                      <div className="org-info-label">Due Date</div>

                      <div className="org-info-value">
                        {convertCurrentDate(
                          getValue(data, `owner_due_date`, ""),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="org-info d-flex align-items-center approval-flow-info is-arrow ">
                <span className="border-arrow-holder"></span>
                <div
                  className="approval-profile-wrap"
                  style={{
                    background: "#D7242E",
                    border: "1px solid #D7242E",
                  }}
                >
                  <span className="m-auto">
                    {getValue(data, `evaluator.first_name`, "").charAt(0)
                      .length > 0
                      ? getValue(data, `evaluator.first_name`, "")
                          .charAt(0)
                          .toUpperCase()
                      : "A"}
                  </span>
                </div>
                <div className="org-info-label-value-wrap approval-flow-label-value-wrap w-100">
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="org-info-label">Evaluator</div>

                      <div className="org-info-value">
                        {getValue(data, `evaluator.first_name`, "") +
                          " " +
                          getValue(data, `evaluator.last_name`, "")}
                      </div>
                    </div>

                    <div className="text-right">
                      <div className="org-info-label">Evaluator Due Date</div>

                      <div className="org-info-value">
                        {convertCurrentDate(
                          getValue(data, `approver_due_date`, ""),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="org-info d-flex align-items-center">
                <div
                  className="approval-profile-wrap"
                  style={{
                    background: "#1A4A89",
                    border: "1px solid #1A4A89",
                  }}
                >
                  <span className="m-auto">
                    {getValue(data, `function_head.first_name`, "").charAt(0)
                      .length > 0
                      ? getValue(data, `function_head.first_name`, "")
                          .charAt(0)
                          .toUpperCase()
                      : "A"}
                  </span>
                </div>
                <div className="org-info-label-value-wrap approval-flow-label-value-wrap w-100">
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="org-info-label">Function Head</div>

                      <div className="org-info-value">
                        {getValue(data, `function_head.first_name`, "") +
                          " " +
                          getValue(data, `function_head.last_name`, "")}
                      </div>
                    </div>

                    <div className="text-right">
                      <div className="org-info-label">
                        Function Head Due Date
                      </div>

                      <div className="org-info-value">
                        {convertCurrentDate(
                          getValue(data, `function_head_due_date`, ""),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>

      <UncontrolledAccordion
        open="3"
        defaultOpen="3"
        className="additional-information-accordion-wrap"
      >
        <AccordionItem>
          <AccordionHeader targetId="3">
            <div className="accordian-header-wrap d-flex align-items-center">
              <EntityMappingSvgComponent />
              <div className="accordion-header-title">Entity Mapping</div>
            </div>
          </AccordionHeader>
          <AccordionBody accordionId="3">
            <div className="org-info-body-wrap">
              {levels.map((item: string, index: number) => {
                if (getValue(data, `self_compliance[${item}]`, "")) {
                  return (
                    <div
                      className="org-info d-flex align-items-center entitiy-mapping-info"
                      key={index}
                    >
                      <EntityMappingDetailsSvgComponent />
                      <div className="org-info-label-value-wrap">
                        <div className="org-info-label">
                          {headerObj[item] && headerObj[item]}
                        </div>

                        <div className="org-info-value">
                          {getValue(
                            data,
                            `self_compliance.[${item}].entity_name`,
                            "",
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
              {levels.map((item: string, index: number) => {
                if (getValue(data, `internal_compliance[${item}]`, "")) {
                  return (
                    <div
                      className="org-info d-flex align-items-center entitiy-mapping-info"
                      key={index}
                    >
                      <EntityMappingDetailsSvgComponent />
                      <div className="org-info-label-value-wrap">
                        <div className="org-info-label">
                          {headerObj[item] && headerObj[item]}
                        </div>

                        <div className="org-info-value">
                          {getValue(
                            data,
                            `internal_compliance.[${item}].ic_entity_name`,
                            "",
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>
      {/* <div className="mb-3">
        {"Compliance Status"} :{" "}
        <b
          style={{
            color: tableStatusColors(getValue(data, `compliance_status`, "")),
          }}
        >
          {formatText(getValue(data, `compliance_status`, ""))}
        </b>
      </div> */}

      {/* <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">Task ID</label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Work Status"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={getValue(data, `task_id`, "")}
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Legal Due Date{" "}
          {getValue(props, `permissions`, []).includes("update") &&
          getValue(data, `compliance_status`, "") !== "COMPLIED" &&
          isDateGreaterThanToday(getValue(data, `legal_due_date`, "")) ? (
            <img
              src="/images/edit.svg"
              className="img-fluid ms-2 cursor-pointer"
              style={{ height: "18px", width: "18px" }}
              onClick={() => {
                setLegal_due_date(
                  new Date(getValue(data, `legal_due_date`, null))
                );
                handleModal();
              }}
            />
          ) : (
            ""
          )}
        </label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Work Status"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={convertCurrentDate(getValue(data, `legal_due_date`, ""))}
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">Executor</label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Work Status"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={
            getValue(data, `executor.first_name`, "") +
            " " +
            getValue(data, `executor.last_name`, "")
          }
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Executor Due Date
        </label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Owner Due Date"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={convertCurrentDate(getValue(data, `owner_due_date`, ""))}
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">Evaluator</label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Work Status"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={
            getValue(data, `evaluator.first_name`, "") +
            " " +
            getValue(data, `evaluator.last_name`, "")
          }
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Evaluator Due Date
        </label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Work Status"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={convertCurrentDate(getValue(data, `approver_due_date`, ""))}
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Function Head
        </label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Work Status"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={
            getValue(data, `function_head.first_name`, "") +
            " " +
            getValue(data, `function_head.last_name`, "")
          }
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Function Head Due Date
        </label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Work Status"
          className="form-control w-100"
          name="license_status"
          id="license_status"
          value={convertCurrentDate(
            getValue(data, `function_head_due_date`, "")
          )}
          label="Work Status"
          disabled
          color="white"
        />
      </div>
      <div className="position-relative form-group  align-items-center cursor-pointer mb-0">
        <h4 className="map-vendor__task-title">Entity Mapping:</h4>
        {levels.map((item: string, index: number) => {
          if (getValue(data, `self_compliance[${item}]`, "")) {
            return (
              <div
                className="user-details-wrapper__form-group form-group"
                key={index}
              >
                <label className="checkpoint-active-details__label">
                  {headerObj[item] && headerObj[item]}
                </label>
                <InputField
                  inputType="TEXT"
                  className="form-control w-100"
                  name="license_status"
                  id="license_status"
                  value={getValue(
                    data,
                    `self_compliance.[${item}].entity_name`,
                    ""
                  )}
                  disabled
                  color="white"
                />
              </div>
            );
          }
        })}
        {levels.map((item: string, index: number) => {
          if (getValue(data, `internal_compliance[${item}]`, "")) {
            return (
              <div
                className="user-details-wrapper__form-group form-group"
                key={index}
              >
                <label className="checkpoint-active-details__label">
                  {headerObj[item] && headerObj[item]}
                </label>
                <InputField
                  inputType="TEXT"
                  className="form-control w-100"
                  name="license_status"
                  id="license_status"
                  value={getValue(
                    data,
                    `internal_compliance.[${item}].ic_entity_name`,
                    ""
                  )}
                  disabled
                  color="white"
                />
              </div>
            );
          }
        })}
      </div> */}
      <Modal isOpen={isOpen} toggle={handleModal}>
        <ModalHeader>
          <h6 className="px-2">
            Are you certain you wish to modify the legal deadline?
          </h6>
        </ModalHeader>
        <ModalBody>
          <div className="desc_text_container d-flex align-items-center">
            <img src="/images/reference.svg" className="image-fluid" />
            <p className="ms-2">
              Kindly be aware that for all recurring checkpoints, any
              alterations to the legal due date will result in updates to the
              configuration, leading to the creation of new tasks based on the
              updated configuration.
            </p>
          </div>

          <div className="user-details-wrapper__form-group form-group input-grid-item mt-3">
            <label className="checkpoint-active-details__label">
              Legal Due Date <span className="form-label-error">*</span>
            </label>
            <div className="position-relative">
              <label onClick={(e) => e.preventDefault()}>
                <InputField
                  inputType="DATETYPE-DOB"
                  className="form-control release-date-wrapper__vendor-form-control--calendar"
                  placeholderText="Enter Approver Due Date"
                  minDate={new Date()}
                  value={legal_due_date}
                  onChange={(e: any) => setLegal_due_date(e)}
                  label={"Evaluator Due Date"}
                />
                <img
                  src="/images/calander.svg"
                  className="img-fluid form-image form-image--calender"
                />
              </label>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={handleModal}
            className="ascent-button ascent-button--header-buttons ascent-button--primary"
          >
            Cancel
          </button>
          <button
            className="ascent-button  ascent-button--header-buttons ascent-button--secondary"
            onClick={handleSubmit}
            disabled={submitLoading}
          >
            {submitLoading ? "Please Wait..." : "Update"}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default OrganizationInformationCommon;
